(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4283],{

/***/ 70006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _unisearch_theme_layout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81496);
/* harmony import */ var _modules_elearning_home__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64529);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);






var Elearning = function Elearning() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_unisearch_theme_layout__WEBPACK_IMPORTED_MODULE_1__/* .LayoutMain */ .Ku, {
    footer_with_evaluation: true,
    title: "eLearning",
    metaUrl: "".concat("https://myunisearch.com", "/elearning"),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_modules_elearning_home__WEBPACK_IMPORTED_MODULE_2__/* .ElearningHomeHero */ .F_, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_modules_elearning_home__WEBPACK_IMPORTED_MODULE_2__/* .ElearningHomeIntro */ .t2, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_modules_elearning_home__WEBPACK_IMPORTED_MODULE_2__/* .ElearningHomeOnlineTest */ .uu, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_modules_elearning_home__WEBPACK_IMPORTED_MODULE_2__/* .ElearningHomeSteps */ .FL, {})]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (Elearning);

/***/ }),

/***/ 77482:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elearning",
      function () {
        return __webpack_require__(70006);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73873:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 41548:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,5445,5937,2013,4617,955,9866,3874,6556,7662,2884,8719,8322,6066,6005,6673,9081,1496,8614,9774,2888,179], function() { return __webpack_exec__(77482); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);